const filterListActionModalFilter = {
  filter: 'FILTERS',
  clearFilter: 'clean filters'
};

export default filterListActionModalFilter;
